import { push } from 'redux-first-history';
import { all, takeEvery, call, put } from 'redux-saga/effects';
import ApiInstance from 'src/helpers/apiInstance';
import actions from './actions';
import { sendRequest } from '../../../../../../../helpers/saga';
import { logger } from '../../../../../../../helpers/logger';
import notifications from '../../../../../../../redux/notifications/actions';
import { t } from '../../../../../../../i18n';

const priceListImportApi = new ApiInstance('companies/:id/skill_rate_groups/import');

function* importCsv({ payload }) {
  const { data, id, isSubUnit } = payload;

  try {
    const result = yield call(
      sendRequest,
      priceListImportApi.post,
      { data, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    const urlPrefix = isSubUnit ? 'subUnits' : 'units';

    if (result.status === 200) {
      yield put(actions.importCsvSuccess());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.created_successfully', {
            item: t('dash.units.unit.priceList.add_new_pricelist.pricing_label'),
          }),
        }),
      );

      yield put(push(`/${urlPrefix}/${id}?tab[]=subUnitPriceList`));
    } else {
      yield put(actions.importCsvError({ errors: result }));
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.talent.bull_form_request_modal.on_submit_error_message'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.IMPORT_CSV_REQUEST, importCsv)]);
}
